import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Organization } from '../../../../../models/entities/organization';
import { UserSettingsService } from '../../../../../services/members/user-settings.service';
import { GrowlerService } from '../../../../../services/growler.service';

export interface AutopayDisableDialogInput
{
    organization: Organization;
}


@Component({
    selector: 'app-autopay-disable-confirmation',
    templateUrl: './autopay-disable-confirmation.component.html',
})
export class AutopayDisableConfirmationComponent implements OnDestroy
{

    constructor(
            private _dialogRef: MatDialogRef<AutopayDisableConfirmationComponent>,
            private _growlerService: GrowlerService,
            private _userSettingsService: UserSettingsService,
            @Inject(MAT_DIALOG_DATA) public data: AutopayDisableDialogInput,
    ) {
    }

    disableAutopay() {
        this._userSettingsService
                .disableAutopaySettings(
                        null,
                        this.data.organization.id,
                )
                .subscribe(
                        () => {
                            this._growlerService.success(
                                    'Success',
                                    `Autopay has been disabled for ${this.data.organization.name}.`,
                            );

                            // TODO use generic confirmation / 'success' (dialog close) interface once available from branch into master
                            this._dialogRef.close(true);
                        },
                        () => {
                            this._growlerService.error('Error', 'Unable to disable your autopay settings.');
                        },
                );
    }

    ngOnDestroy() {
    }

}
